import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
export class StorageService {
    constructor() {
        this.changes$ = new Subject();
        this.localStorage = window.localStorage;
    }
    get(key) {
        if (this.isLocalStorageSupported) {
            const value = this.localStorage.getItem(key);
            if (value && value !== 'undefined') {
                return JSON.parse(value);
            }
            else {
                return value;
            }
        }
        else {
            console.log(this.changes$.subscribe(data => data));
        }
        return null;
    }
    set(key, value) {
        if (this.isLocalStorageSupported) {
            this.localStorage.setItem(key, JSON.stringify(value));
            this.changes$.next({
                type: 'set',
                key,
                value
            });
            return true;
        }
        return false;
    }
    remove(key) {
        if (this.isLocalStorageSupported) {
            this.localStorage.removeItem(key);
            this.changes$.next({
                type: 'remove',
                key
            });
            return true;
        }
        return false;
    }
    clearAll() {
        this.localStorage.clear();
    }
    get isLocalStorageSupported() {
        return !!this.localStorage;
    }
}
StorageService.ɵfac = function StorageService_Factory(t) { return new (t || StorageService)(); };
StorageService.ɵprov = i0.ɵɵdefineInjectable({ token: StorageService, factory: StorageService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(StorageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
//# sourceMappingURL=storage.service.js.map